import styled from 'styled-components';
import { styledByTheme } from '../../../themes/architecture/styled-by-theme';

const GameItemTitleDefaultBox = styled.div`
    margin-bottom: 0.5rem;
    width: 15rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 1.3rem;
    ${({theme}) => theme.font.presets.regular};
    color: ${({theme}) => theme.colors.textLight};
`;
const GameItemTitleCasino777Box = styled(GameItemTitleDefaultBox)`
    font-size: 1.5rem;
`;
export const GameItemTitleBox = styledByTheme(GameItemTitleDefaultBox).forCasino777(GameItemTitleCasino777Box).apply();
